// Subscription Plans Configuration
// Pricing: INR base with USD equivalent shown
// ₹500 Professional / ₹1000 Premium (same for Trainers & Corporates)

const INR_TO_USD = 83; // approximate conversion rate

export const BILLING_PERIODS = {
  monthly: { id: 'monthly', label: 'Monthly', discount: 0 },
  annual: { id: 'annual', label: 'Annual', discount: 20, badge: 'Save 20%' }
};

export const TRAINER_PLANS = {
  basic: {
    id: 'basic',
    name: 'Basic',
    priceINR: 0,
    priceUSD: 0,
    annualPriceINR: 0,
    annualPriceUSD: 0,
    description: 'Get started with essential features',
    features: [
      { text: 'Create trainer profile', included: true },
      { text: 'Apply to 5 training requirements/month', included: true },
      { text: 'Basic profile visibility', included: true },
      { text: 'Email notifications', included: true },
      { text: 'Standard support', included: true },
      { text: 'Profile analytics', included: false },
      { text: 'Priority in search results', included: false },
      { text: 'Featured badge', included: false },
      { text: 'Homepage ad runner', included: false },
      { text: 'Unlimited job applications', included: false }
    ],
    limits: {
      applicationsPerMonth: 5,
      profileBoost: false,
      adRunner: false,
      badge: null,
      prioritySupport: false
    },
    popular: false,
    color: 'slate'
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    priceINR: 500,
    priceUSD: 6,
    annualPriceINR: 4800,
    annualPriceUSD: 58,
    description: 'Boost your visibility and opportunities',
    features: [
      { text: 'Create trainer profile', included: true },
      { text: 'Unlimited applications', included: true },
      { text: 'Enhanced profile visibility', included: true },
      { text: 'Email notifications', included: true },
      { text: 'Priority support', included: true },
      { text: 'Profile analytics dashboard', included: true },
      { text: 'Priority in search results', included: true },
      { text: '"Pro Trainer" badge', included: true },
      { text: 'Homepage ad runner', included: false },
      { text: 'Dedicated account manager', included: false }
    ],
    limits: {
      applicationsPerMonth: -1,
      profileBoost: true,
      adRunner: false,
      badge: 'pro',
      prioritySupport: true
    },
    popular: true,
    color: 'blue'
  },
  premium: {
    id: 'premium',
    name: 'Premium',
    priceINR: 1000,
    priceUSD: 12,
    annualPriceINR: 9600,
    annualPriceUSD: 115,
    description: 'Maximum exposure and premium benefits',
    features: [
      { text: 'All Professional features', included: true },
      { text: 'Homepage ad runner display', included: true },
      { text: '"Premium Trainer" badge', included: true },
      { text: 'Top priority in search results', included: true },
      { text: 'Featured on landing page', included: true },
      { text: 'Dedicated account manager', included: true },
      { text: 'Custom profile URL', included: true },
      { text: 'Video profile introduction', included: true },
      { text: 'Direct messaging with companies', included: true },
      { text: 'Early access to new requirements', included: true }
    ],
    limits: {
      applicationsPerMonth: -1,
      profileBoost: true,
      adRunner: true,
      badge: 'premium',
      prioritySupport: true,
      accountManager: true
    },
    popular: false,
    color: 'purple'
  }
};

export const COMPANY_PLANS = {
  basic: {
    id: 'basic',
    name: 'Basic',
    priceINR: 0,
    priceUSD: 0,
    annualPriceINR: 0,
    annualPriceUSD: 0,
    description: 'Perfect for small businesses getting started',
    features: [
      { text: 'Post up to 3 requirements/month', included: true },
      { text: 'Basic company profile', included: true },
      { text: 'View trainer profiles', included: true },
      { text: 'Email notifications', included: true },
      { text: 'Standard support', included: true },
      { text: 'Unlimited requirement posts', included: false },
      { text: 'Featured requirement listings', included: false },
      { text: 'Homepage ad runner', included: false },
      { text: 'Advanced analytics', included: false },
      { text: 'API access', included: false }
    ],
    limits: {
      jobPostsPerMonth: 3,
      featuredJobs: false,
      adRunner: false,
      badge: null,
      prioritySupport: false
    },
    popular: false,
    color: 'slate'
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    priceINR: 500,
    priceUSD: 6,
    annualPriceINR: 4800,
    annualPriceUSD: 58,
    description: 'Scale your training programs efficiently',
    features: [
      { text: 'Unlimited requirement posts', included: true },
      { text: 'Enhanced company profile', included: true },
      { text: 'Featured requirement listings', included: true },
      { text: 'Priority in search results', included: true },
      { text: 'Advanced analytics dashboard', included: true },
      { text: 'Email notifications', included: true },
      { text: 'Priority support', included: true },
      { text: '"Verified Business" badge', included: true },
      { text: 'Homepage ad runner', included: false },
      { text: 'Dedicated account manager', included: false }
    ],
    limits: {
      jobPostsPerMonth: -1,
      featuredJobs: true,
      adRunner: false,
      badge: 'verified',
      prioritySupport: true
    },
    popular: true,
    color: 'blue'
  },
  premium: {
    id: 'premium',
    name: 'Premium',
    priceINR: 1000,
    priceUSD: 12,
    annualPriceINR: 9600,
    annualPriceUSD: 115,
    description: 'Complete solution for large organizations',
    features: [
      { text: 'All Professional features', included: true },
      { text: 'Homepage ad runner display', included: true },
      { text: '"Premium Employer" badge', included: true },
      { text: 'Top priority placement', included: true },
      { text: 'Featured on landing page', included: true },
      { text: 'Dedicated account manager', included: true },
      { text: 'Custom branding options', included: true },
      { text: 'API access', included: true },
      { text: 'Bulk trainer invitations', included: true },
      { text: 'White-glove onboarding', included: true }
    ],
    limits: {
      jobPostsPerMonth: -1,
      featuredJobs: true,
      adRunner: true,
      badge: 'premium',
      prioritySupport: true,
      accountManager: true,
      apiAccess: true
    },
    popular: false,
    color: 'purple'
  }
};

// Helper functions
export const getPlanById = (type, planId) => {
  if (type === 'trainer') {
    return TRAINER_PLANS[planId] || TRAINER_PLANS.basic;
  }
  return COMPANY_PLANS[planId] || COMPANY_PLANS.basic;
};

export const getAllPlans = (type) => {
  if (type === 'trainer') {
    return Object.values(TRAINER_PLANS);
  }
  return Object.values(COMPANY_PLANS);
};

export const formatPrice = (plan, billing = 'monthly', currency = 'dual') => {
  if (!plan) return 'Free';
  const isAnnual = billing === 'annual';

  const inr = isAnnual ? plan.annualPriceINR : plan.priceINR;
  const usd = isAnnual ? plan.annualPriceUSD : plan.priceUSD;

  if (inr === 0) return 'Free';

  if (currency === 'inr') return `₹${inr.toLocaleString('en-IN')}`;
  if (currency === 'usd') return `$${usd}`;
  // dual: show both
  return { inr: `₹${inr.toLocaleString('en-IN')}`, usd: `$${usd}` };
};

export const getMonthlyEquivalent = (plan, billing = 'monthly') => {
  if (billing !== 'annual') return null;
  const monthlyINR = Math.round(plan.annualPriceINR / 12);
  const monthlyUSD = Math.round(plan.annualPriceUSD / 12 * 100) / 100;
  if (monthlyINR === 0) return null;
  return { inr: `₹${monthlyINR.toLocaleString('en-IN')}`, usd: `$${monthlyUSD}` };
};

export default {
  TRAINER_PLANS,
  COMPANY_PLANS,
  BILLING_PERIODS,
  getPlanById,
  getAllPlans,
  formatPrice,
  getMonthlyEquivalent
};
